<template>
    <div
        v-if="items && items.length"
        class="banners"
    >
        <BaseBanner
            v-for="(item, index) in items"
            :key="index"
            :url="`/${item.uri}`"
            :image="item.logo ? item.logo[0] : null"
            :class="{ 'banner--secondary': secondaryStyle }"
        >
            {{ item.title }}
        </BaseBanner>
    </div>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
        default: () => [],
    },
    secondaryStyle: {
        type: Boolean,
        required: false,
        default: false,
    },
});
</script>

<style lang="less" src="./BaseBanners.less" />
